const PurchaseNotificationSettings = () => {
  return;
};

export default PurchaseNotificationSettings;
